// Tunables taken from the original GTK engine (board_engine.c).

/** Board dimensions in cells. Width is the number of columns, height the number of rows. */
export interface BoardSize {
  readonly width: number;
  readonly height: number;
}

export const DEFAULT_BOARD_SIZE: BoardSize = { width: 8, height: 8 };
/** Smallest and largest allowed width or height, in cells. */
export const MIN_BOARD_CELLS = 4;
export const MAX_BOARD_CELLS = 16;

export const NUM_GEM_TYPES = 7;

/** Gems that must be removed before the first level bonus. */
export const FIRST_BONUS_AT = 100;
/** Number of random single-gem removals granted by a level bonus. */
export const NB_BONUS_GEMS = 8;
/** Timer mode: how many penalty steps a level's span is divided into. */
export const TOTAL_STEPS_FOR_TIMER = 180;
/** Idle time before a hint gem bounces. */
export const HINT_TIMEOUT_MS = 15_000;
/** How long a hint gem keeps bouncing. */
export const HINT_GEM_BOUNCE_MS = 2_000;
/** Game engine tick. The original ran its state machine every 50 ms. */
export const TICK_MS = 50;
/** Delay between "game over" and the high score dialog. */
export const GAME_OVER_DELAY_MS = 1_000;

export const MAX_HISCORES = 10;

export const GameMode = {
  Normal: "normal",
  Timed: "timed",
  Endless: "endless",
} as const;
export type GameMode = (typeof GameMode)[keyof typeof GameMode];

export const GAME_MODE_NAMES: Record<GameMode, string> = {
  [GameMode.Normal]: "Normal",
  [GameMode.Timed]: "Timed",
  [GameMode.Endless]: "Endless",
};
